import {jwtDecode} from 'jwt-decode';

export function checkAuthStatus() {
    const token = localStorage.getItem('adminToken');
  
    if (!token) {
      return { isLoggedIn: false, isAdmin: false, tokenValid: false };
    }
  
    try {
      const decodedToken = jwtDecode(token);
      const isTokenExpired = decodedToken.exp * 1000 < Date.now();
      const isAdmin = decodedToken.isAdmin === true;
      const isLoggedIn = decodedToken.is_Logged_in === "true";
  
      return {
        isLoggedIn: isLoggedIn,
        isAdmin: isAdmin,
        tokenValid: !isTokenExpired,
      };
    } catch (error) {
      console.error('Token is invalid:', error);
      return { isLoggedIn: false, isAdmin: false, tokenValid: false };
    }
  }
